<template>
    <div>
        <div class="nk-block-head nk-block-head-sm">
            <div class="nk-block-between">
                <div class="nk-block-head-content">
                    <h3 class="nk-block-title page-title">{{trans('configuration.configuration')}}</h3>
                    <div class="nk-block-des text-soft">
                        <p>{{ trans('general.scheduled_job') }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="admin-config-layout admin-linear-page">
            <configuration-sidebar menu="scheduled-job"></configuration-sidebar>
            <div class="admin-config-panel">
                <div class="admin-config-panel__inner">
                    <div class="admin-linear-head">
                        <div>
                            <span class="admin-linear-head__eyebrow">Maintenance</span>
                            <h4 class="admin-linear-head__title">{{trans('configuration.scheduled_job')}}</h4>
                            <p class="admin-linear-head__description">Confirm the server cron command and review the jobs Laravel will run on schedule.</p>
                        </div>
                        <div class="admin-linear-stat">
                            <span>Configured jobs</span>
                            <strong>2</strong>
                        </div>
                    </div>
                    <show-tip module="configuration" tip="tip_scheduled_job"></show-tip>
                    <section class="admin-config-section mt-3" :aria-label="trans('configuration.scheduled_job')">
                        <div class="admin-linear-section-label">Scheduler command</div>
                        <h4 class="admin-config-section__title">{{trans('configuration.scheduled_job')}}</h4>
                        <p class="admin-config-section__description">Server cron must call Laravel's scheduler so background tasks run at the expected time.</p>
                        <div class="admin-linear-command-card mb-4">
                            <div>
                                <span>Cron command</span>
                                <code>php /path-to-artisan schedule:run >> /dev/null 2>&1</code>
                            </div>
                        </div>
                        <div class="admin-list-table-card admin-config-list-card">
                            <div class="table-responsive">
                                <table class="table admin-data-table admin-data-table--config-list admin-linear-table mb-0">
                                    <thead>
                                        <tr>
                                            <th scope="col">Action</th>
                                            <th scope="col">Frequency</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <strong class="admin-linear-primary">Birthday/Anniversary wish to Staff/Customer</strong>
                                            </td>
                                            <td><span class="admin-linear-pill">Once per day at 09:00 AM</span></td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <strong class="admin-linear-primary">Daily Backup</strong>
                                            </td>
                                            <td><span class="admin-linear-pill">Once per day at 01:00 AM</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import configurationSidebar from '../system-config-sidebar'

    export default {
        components : { configurationSidebar },
        data() {
            return {

            }
        },
        mounted(){
            if(!helper.hasPermission('access-configuration')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }
        },
        methods: {
        }
    }
</script>

<style scoped>
.admin-linear-head {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 1.25rem;
    margin-bottom: 1.25rem;
    padding: 1.1rem 1.2rem;
    border: 1px solid var(--dash-pro-border);
    border-radius: var(--dash-pro-radius-sm);
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.06), var(--dash-pro-surface));
}

.admin-linear-head__eyebrow,
.admin-linear-section-label,
.admin-linear-command-card span {
    display: block;
    color: var(--lms-primary);
    font-size: 0.68rem;
    font-weight: 800;
    letter-spacing: 0.09em;
    text-transform: uppercase;
}

.admin-linear-head__title {
    margin: 0.35rem 0 0;
    color: var(--dash-pro-text);
    font-size: 1.35rem;
    font-weight: 700;
    letter-spacing: -0.04em;
}

.admin-linear-head__description {
    max-width: 42rem;
    margin: 0.45rem 0 0;
    color: var(--dash-pro-muted);
    font-size: 0.875rem;
    line-height: 1.55;
}

.admin-linear-stat {
    min-width: 8.5rem;
    padding: 0.85rem 1rem;
    border: 1px solid var(--dash-pro-border);
    border-radius: var(--dash-pro-radius-sm);
    background: var(--dash-pro-surface);
    text-align: right;
}

.admin-linear-stat span {
    display: block;
    color: var(--dash-pro-muted);
    font-size: 0.72rem;
    font-weight: 700;
}

.admin-linear-stat strong {
    display: block;
    margin-top: 0.25rem;
    color: var(--dash-pro-text);
    font-size: 1.65rem;
    letter-spacing: -0.06em;
}

.admin-linear-section-label {
    margin-bottom: 0.35rem;
}

.admin-linear-command-card {
    padding: 1rem 1.1rem;
    border: 1px solid var(--dash-pro-border);
    border-radius: var(--dash-pro-radius-sm);
    background: var(--dash-pro-bg);
}

.admin-linear-command-card code {
    display: block;
    margin-top: 0.45rem;
    color: var(--dash-pro-text);
    font-size: 0.85rem;
    white-space: normal;
    word-break: break-word;
}

.admin-linear-primary {
    color: var(--dash-pro-text);
    font-weight: 650;
}

.admin-linear-pill {
    display: inline-flex;
    align-items: center;
    min-height: 1.65rem;
    padding: 0.15rem 0.6rem;
    border: 1px solid var(--dash-pro-border);
    border-radius: 999px;
    color: var(--dash-pro-text-secondary);
    font-size: 0.75rem;
    font-weight: 700;
}

@media (max-width: 767.98px) {
    .admin-linear-head {
        align-items: stretch;
        flex-direction: column;
    }

    .admin-linear-stat {
        text-align: left;
    }
}
</style>
